// extracted by mini-css-extract-plugin
export default {"emptyEntities":"EmptyEntities_emptyEntities__sRkQL"};